import type { SiteConfigFn } from '@wix/thunderbolt-vsm-api-types'
import type { ProtectedPagesSiteConfig } from '../types'

const protectedPagesSiteConfig: SiteConfigFn<ProtectedPagesSiteConfig> = ({ api }) => {
	// Check if there are protected pages (pages without pageJsonFileName)
	const pagesMap = api.rendererModel.getPagesMap()
	let hasProtectedPages = false
	for (const page of Object.values(pagesMap)) {
		if (!page.pageJsonFileName) {
			hasProtectedPages = true
			break
		}
	}

	if (!hasProtectedPages) {
		return {
			shouldLoadSiteFeature: false,
			shouldLoadSiteConfig: false,
			siteConfig: null,
		}
	}

	// Get password protected pages
	const passwordProtectedArray = api.rendererModel.getPasswordProtectedPages() || []
	const passwordProtected: { [pageId: string]: string } = {}
	for (const pageId of passwordProtectedArray) {
		passwordProtected[pageId] = pageId
	}

	// Get public page IDs (pages with pageJsonFileName)
	const publicPageIds: string[] = []
	for (const [pageId, page] of Object.entries(pagesMap)) {
		if (page.pageJsonFileName) {
			publicPageIds.push(pageId)
		}
	}

	// Build pageUriSeoToRouterPrefix (only from valid routers, matching Carmi behavior)
	const routersConfig = api.rendererModel.getRouters()?.configMap || {}
	const pageUriSeoToRouterPrefix: { [pageUriSeo: string]: string } = {}

	for (const router of Object.values(routersConfig)) {
		const appDefinitionId = router.appDefinitionId
		if (
			!api.router.isValidWixCodeAppRouterConfig(appDefinitionId) &&
			!api.router.isValidDataBindingAppRouterConfig(appDefinitionId) &&
			!api.router.isValidPlatformAppRouterConfig(appDefinitionId) &&
			!api.router.isValidAppRouterExtensionConfig(appDefinitionId)
		) {
			continue
		}

		const prefix = router.prefix
		const pages = router.pages || {}

		for (const pageId of Object.values(pages)) {
			const page = pagesMap[pageId]
			if (page) {
				pageUriSeoToRouterPrefix[page.pageUriSEO] = prefix
			}
		}
	}

	const siteConfig: ProtectedPagesSiteConfig = {
		passwordProtected,
		publicPageIds,
		pageUriSeoToRouterPrefix,
	}

	return {
		shouldLoadSiteFeature: true,
		shouldLoadSiteConfig: true,
		siteConfig,
	}
}

const name = 'protectedPages'

export const config = { site: protectedPagesSiteConfig, name }
